import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  margin-inline: 25px;
  padding-bottom: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 100%;
  max-width: 1400px;
`;

export const ModelSelectorAndRecentActivityContainer = styled.div`
  display: grid;
  grid-template-columns: 40fr 60fr;  
  gap: 24px;
  width: 100%;
  align-items: flex-start;
`;

export const NotesAndTasksContainer = styled.div`
  display: grid;
  grid-template-columns: 38fr 62fr;  
  gap: 24px;
  width: 100%;
`;

export const RepairOrdersAndAppointmentsContainer = styled.div`
  display: grid;
  grid-template-columns: 62fr 38fr;
  gap: 24px;
  width: 100%;
`;

export const DealershipTeamAndFISalesContainer = styled.div`
  display: grid;
  grid-template-columns: 68fr 32fr;  
  gap: 24px;
  width: 100%;
`;

export const WidgetGridContainer = styled.div`
  width: 100%;
  min-height: 400px;
`;